import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { AbsenceEntity } from '@wilson/interfaces';
import {
  DropZoneEventThrottlerDirective,
  GanttDateToPositionPxPipe,
  TimelineCellHighlightService,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { CreateNewViaDragAndDropService } from '@wilson/shift-timeline/services';
import {
  TimelineRemoveAbsence,
  TimelineStaysSuggestionService,
} from '@wilson/shift-timeline/state';
import { NewAbsenceDropZoneService } from '../new-absence-drop-zone/new-absence-drop-zone.service';

@Component({
  selector: 'wilson-new-absence-drop-zone-cell-view',
  imports: [],
  template: '',
  styleUrls: ['./new-absence-drop-zone-cell-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GanttDateToPositionPxPipe],
})
export class NewAbsenceDropZoneCellViewComponent extends DropZoneEventThrottlerDirective {
  private store = inject(Store);
  private readonly newAbsenceDropZoneService = inject(
    NewAbsenceDropZoneService,
  );
  protected timelineStaysSuggestionService = inject(
    TimelineStaysSuggestionService,
  );
  private readonly timelineCellHighlightService = inject(
    TimelineCellHighlightService,
  );

  @Input() userId!: string | undefined;

  private mockAbsence!: undefined | (AbsenceEntity & { id: string });

  protected async onDropHandler() {
    if (this.mockAbsence && this.userId) {
      this.newAbsenceDropZoneService.handleOnDropProcess({
        currentDemarcatorRange: null,
        mockAbsence: this.mockAbsence,
        userId: this.userId,
      });
    }
    this.timelineCellHighlightService.clearCellsFromHighlight();
  }

  protected onDragLeaveHandler() {
    if (this.userId) {
      this.removeMockAbsenceFromState(this.userId);
    }
    this.timelineCellHighlightService.clearCellsFromHighlight();
  }

  protected onDragOverHandler(offsetX: number) {
    this.timelineCellHighlightService.clearCellsFromHighlight();
    const processingResult =
      this.newAbsenceDropZoneService.handleOnDragOverProcess({
        offsetX: offsetX,
        userId: this.userId,
        isFullDay: true,
      });

    if (processingResult) {
      this.mockAbsence = processingResult.mockAbsence;
      this.timelineCellHighlightService.setCellToHighlight(
        this.userId as string,
        processingResult.mockAbsence?.absentFrom as string,
      );
    }
  }

  private removeMockAbsenceFromState(userId: string) {
    this.store.dispatch(
      new TimelineRemoveAbsence({
        absenceId: CreateNewViaDragAndDropService.MOCK_ABSENCE_ID,
        userId: userId,
      }),
    );
  }
}
